let fontLoadPromise = null;

export function loadWidgetFonts() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return Promise.resolve();
  }

  if (fontLoadPromise) {
    return fontLoadPromise;
  }

  fontLoadPromise = Promise.all([
    import("typeface-montserrat"),
    import("typeface-roboto"),
  ])
    .then(() => {
      document.documentElement.classList.add("widget-fonts-ready");
    })
    .catch((error) => {
      console.warn("Unable to load widget fonts locally", error);
    });

  return fontLoadPromise;
}
